import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SignatureBg } from "../components/SignatureBg";
import { staffAuth } from "../lib/api";
import { PasswordRequirements, passwordOk } from "../components/PasswordRequirements";

export default function ResetPasswordPage() {
  const nav = useNavigate();
  const { token = "" } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const pwOk = passwordOk(password);
  const mismatch = confirm.length > 0 && confirm !== password;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!pwOk) { setError("Please meet all the password requirements below."); return; }
    if (password !== confirm) { setError("Passwords don't match."); return; }
    setBusy(true); setError(null);
    try {
      await staffAuth.resetPassword(token, password);
      setDone(true);
    } catch (e: any) {
      setError(e?.message || "This reset link is invalid or expired. Request a new one.");
      setBusy(false);
    }
  }

  return (
    <div className="login-page has-signature-bg">
      <SignatureBg />
      <div className="login-card">
        <div className="brand-lockup login-brand">
          <div className="brand-mark">
            <img src="/brand-mark.png" alt="Alief Dispute Hub" />
          </div>
          <div>
            <strong className="brand-wordmark">Alief Dispute Hub</strong>
            <span>Analyze Smarter. Dispute Better.</span>
          </div>
        </div>
        {done ? (
          <>
            <h1>Password updated</h1>
            <p className="muted" style={{ margin: "0 0 16px" }}>You can sign in with your new password now.</p>
            <button className="primary-button wide-button" onClick={() => nav("/login")}>Go to sign-in</button>
          </>
        ) : (
          <>
            <h1 id="reset-heading">Choose a new password</h1>
            <form onSubmit={submit} className="stacked-form" aria-labelledby="reset-heading">
              <label className="form-field">
                <span>New password</span>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password" placeholder="At least 8 characters" required />
                <PasswordRequirements password={password} />
              </label>
              <label className="form-field">
                <span>Confirm password</span>
                <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  autoComplete="new-password" placeholder="Re-enter your password" required />
                {mismatch && <span className="error-text">Passwords don't match.</span>}
              </label>
              {error && <p className="error-text" role="alert">{error}</p>}
              <button className="primary-button wide-button" disabled={busy || !pwOk || password !== confirm}>
                {busy ? "Saving…" : "Update password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
